import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import Button from 'admin/components/shared/Button';
import styles from './styles.scss';

const S = { text: "S", label: "A8" };
const M = { text: "M", label: "A7" };
const L = { text: "L", label: "A6" };

class Picker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSize: S,
    }
  }

  handleClickInactiveSizeButton(size) {
    this.setState({ selectedSize: size });
  }

  handleClickDownloadButton = () => {
    this.props.download(this.state.selectedSize.text);
  }

  renderSizeButtons() {
    const sizes = [S, M, L];
    return sizes.map((size) => (
      <div styleName="size-button-box" key={size.label}>
        {this.state.selectedSize === size ?
          <Button styleName="active-size-button">{size.text}</Button> :
          <Button styleName="inactive-size-button" onClick={this.handleClickInactiveSizeButton.bind(this, size)}>{size.text}</Button>}
        <span styleName="size-comment">{size.label}</span>
      </div>
    ));
  }

  render() {
    return (
      <div styleName="box">
        <div styleName="size-chooser">
          <span styleName="size-layout-title">サイズを選択</span>
          <div styleName="size-button-layout">
            {this.renderSizeButtons()}
          </div>
        </div>
        {
          this.props.canDownload ?
            <Button styleName="enable-download-button" onClick={this.handleClickDownloadButton}>ダウンロード</Button> :
            <Button styleName="disable-download-button">ダウンロード</Button>
        }
      </div>
    );
  }
}

Picker.propTypes = {
  download: PropTypes.func.isRequired,
  canDownload: PropTypes.bool.isRequired,
}

export default CSSModules(Picker, styles);
